<template>
  <b-overlay :show="isLoading">
    <h4>點數異動紀錄</h4>
    <div
      v-if="upperCustomerId && availablePoint !== null"
      class="font-weight-bold"
      style="font-size: 14px;"
    >
      可用點數
      <span id="availablePointTip" class="mdi mdi-help-circle-outline"></span>：{{ availablePoint }}
      <b-tooltip target="availablePointTip" triggers="hover">
        點數為此會員的總點數（跨通路累積
      </b-tooltip>
    </div>

    <div class="row mx-0 justify-content-between mb-2 mt-3">
      <div>
        <b-button v-b-toggle="['collapse-filter']" variant="outline-info">
          <span class="mdi mdi-magnify"></span>進階搜尋
        </b-button>
      </div>
      <div>
        <b-button
          v-if="showAddButton"
          class="flex-shrink-0 mb-0 ml-2 btn"
          variant="primary"
          v-b-modal.modal-add
        >
          <i class="mdi mdi-plus-circle-outline"></i>
          手動給點
        </b-button>
        <b-button
          v-if="showUseButton"
          class="flex-shrink-0 mb-0 ml-2 btn"
          variant="inverse-primary"
          v-b-modal.modal-use
        >
          <i class="mdi mdi-minus-circle-outline"></i>
          手動扣點
        </b-button>
        <b-button
          class="flex-shrink-0 mb-0 ml-2 btn"
          variant="primary"
          @click="handleExport"
          v-if="showFilter && query.merchant_id"
        >
          <i class="fa fa-plus"></i>匯出 excel
        </b-button>
      </div>
    </div>

    <b-collapse id="collapse-filter" class="mt-2">
      <b-card>
        <b-form >
          <div class="d-flex flex-column flex-xl-row flex-wrap">
            <b-form-group
              v-if="!showFilter"
              label="通路名稱"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <AppSingleSelect
                v-model="selectedMerchant"
                :options="merchants"
                @input="onMerchantChange"
                :disabled="merchants.length == 2"
              ></AppSingleSelect>
            </b-form-group>

            <b-form-group
              v-if="!showFilter"
              label="點數增減"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <AppSingleSelect
                v-model="selectedType"
                :options="typeOptions"
                @input="onTypeChange"
              ></AppSingleSelect>
            </b-form-group>

            <b-form-group
              v-if="showFilter"
              label="分店名稱"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <AppSingleSelect
                v-model="selectedBranch"
                :options="branchOptions"
                @input="branchChange"
                :disabled="disabledBranchSelect"
              ></AppSingleSelect>
            </b-form-group>

            <b-form-group
              v-if="showFilter"
              label="點數增減"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <AppSingleSelect
                v-model="selectedType"
                :options="typeOptions"
                @input="onTypeChange"
              ></AppSingleSelect>
            </b-form-group>

            <b-form-group
              v-if="showFilter"
              label="異動來源"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <AppSingleSelect
                v-model="selectedSource"
                :options="sourceOptions"
                @input="onSourceChange"
              ></AppSingleSelect>
            </b-form-group>

            <b-form-group
              v-if="showFilter"
              label="活動代碼"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <event-select
                v-model="query.event_id"
                @change="handlePageReset"
              ></event-select>
            </b-form-group>

            <b-form-group
              v-if="showFilter"
              label="通路名稱"
              label-cols-sm="3"
              label-cols-lg="2"
              content-cols-sm
              content-cols-lg="7"
              style="width: 50%"
            >
              <AppSingleSelect
                v-model="selectedMerchant"
                :options="merchants"
                :disabled="merchants.length == 2"
                @input="onMerchantChange"
              ></AppSingleSelect>
            </b-form-group>


          </div>
        </b-form>
      </b-card>
    </b-collapse>


    <b-card class="mt-2" v-if="showFilter && query.merchant_id">
      <b-input-group>
        <b-form-input
          placeholder="搜尋會員名稱、手機、外部編碼"
          v-model="query.keyword"
          style="max-width: 500px;"
          @keyup.enter="handleSearch"
        ></b-form-input>
        <b-input-group-append>
          <b-button @click="handleSearch">
            <i class="fa fa-search"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-card>

    <b-table
      striped
      hover
      responsive
      :items="pointLogs"
      :fields="filteredFields"
      :no-local-sorting="true"
      @sort-changed="handleSort"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>

      <template #cell(batch_total_points)="data">
        <span :style="{ color: data.item.batch_total_points < 0 ? '#ff6258' : 'inherit' }">
          {{ data.item.batch_total_points }}
        </span>
      </template>

      <template #cell(customer_name)="data">
        {{ data.item.customer_name | hiddenString(20) }}
      </template>
      <template #cell(created_at)="data">
        {{ formatDate(data.item.created_at) }}
      </template>
      <template #cell(start_at)="data">
        {{ formatDate(data.item.start_at) }}
      </template>
      <template #cell(expired_at)="data">
        {{ showExpiredAt(data.item) }}
      </template>
      <template #cell(actions)="data">
        <b-button
          class="ml-2"
          variant="inverse-info"
          :to="{
            name: 'PointDetail',
            params: {
              pointLogId: data.item.id,
            },
          }"
        >查看點數內容</b-button
        >
      </template>
    </b-table>

    <CustomPagination
      :currentPage="query.page"
      :totalRows="total"
      :perPage="query.per_page"
      @page-change="handlePageChange"
      @per-page-change="handlePerPageChange"
    />

    <b-modal id="modal-use" title="要扣除多少點數？" @show="resetPointForUse">
      <b-form-group
        label-cols="12"
        label-cols-lg="2"
        label-size="sm"
        label="點數"
      >
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="pointForUse.point"
          placeholder="輸入10 (將扣除10點) "
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols="12"
        label-cols-lg="2"
        label-size="sm"
        label="說明"
      >
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="pointForUse.description"
        ></b-form-input>
      </b-form-group>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
        <b-button size="sm" variant="outline-primary" @click="usePoint" :disabled="isSubmittingUse">
          確定
        </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-add" title="請問要增加多少點？" @show="resetPoint">
      <b-form-group
        label-cols="12"
        label-cols-lg="2"
        label-size="sm"
        label="點數"
      >
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="point.point"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols="12"
        label-cols-lg="2"
        label-size="sm"
        label="說明"
      >
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="point.description"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols="12"
        label-cols-lg="2"
        label-size="sm"
        label="開始時間"
      >
        <div class="d-flex align-items-center">
          <datepicker
            placeholder="選擇日期"
            v-model="point.start_at_date"
            bootstrap-styling
            format="yyyy-MM-dd"
            :language="zh"
            clear-button
            :typeable="true"
            class="mr-2"
            style="flex: 1"
          ></datepicker>
          <vue-timepicker
            placeholder="選擇時間"
            format="HH:mm"
            v-model="point.start_at_time"
            :input-class="['form-control', 'text-center']"
            style="width: 120px"
            clearable
            @keyup.native.delete="point.start_at_time = { HH: '', mm: '' }"
            @keyup.native.backspace="point.start_at_time = { HH: '', mm: '' }"
          ></vue-timepicker>
        </div>
      </b-form-group>

      <b-form-group
        label-cols="12"
        label-cols-lg="2"
        label-size="sm"
        label="過期時間"
      >
        <div class="d-flex align-items-center">
          <datepicker
            placeholder="選擇日期"
            v-model="point.expired_at_date"
            bootstrap-styling
            format="yyyy-MM-dd"
            :language="zh"
            clear-button
            :typeable="true"
            class="mr-2"
            style="flex: 1"
          ></datepicker>
          <b-form-input
            :value="point.expired_at_date ? '23:59' : ''"
            readonly
            disabled
            class="bg-light text-center"
            style="width: 120px"
          ></b-form-input>
        </div>
      </b-form-group>

      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
        <b-button size="sm" variant="outline-primary" @click="addPoint" :disabled="isSubmittingAdd">
          確定
        </b-button>
      </template>
    </b-modal>
  </b-overlay>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import pointLogApi from "@/apis/point-log";
import pointApi from "@/apis/point";
import merchantApi from "@/apis/merchant";
import store from "@/store";
import moment from "moment";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import EventSelect from "@/components/Dashboard/EventSelect";
import { updateQueryFromRoute, updateUrl, updateUrlWithoutReload } from "@/utils/updateUrl";
import * as consts from "@/consts";
import { paginationMixin } from "@/mixins/pagination";
import branchApi from "@/apis/branch";
import AppSingleSelect from "@/components/AppSingleSelect.vue";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import { zh } from "vuejs-datepicker/dist/locale";
import { format, set } from "date-fns";
import PermissionChecker from "@/utils/PermissionChecker";

export default {
  mixins: [paginationMixin],
  components: {AppSingleSelect, EventSelect, CustomPagination, Datepicker, VueTimepicker },
  props: {
    /* true: 完整模式, false: 簡化模式 */
    showFilter: {
      type: Boolean,
      default: true,
    },
    excludeFields: {
      type: Array,
      default: () => [],
    },
    upperMerchantId: {
      type: String,
      default: null,
    },
    upperCustomerId: {
      type: [Number, String],
      default: null,
    },
    upperTargetType: {
      type: String,
      default: null,
    },
    upperTargetId: {
      type: String,
      default: null,
    },
    prefixFileName: {
      type: String,
      default: null,
    },
  },
  data() {
    const baseFields = [
      {
        key: "customer_name",
        label: "會員名稱",
        sortable: true,
      },
      {
        key: "batch_total_points",
        label: "異動點數",
      },

      {
        key: "type",
        label: "異動類型",
      },
      {
        key: "source_name",
        label: "異動來源",
      },
      {
        key: "source_description",
        label: "異動說明",
      },
      {
        key: "branch.name",
        label: "分店名稱",
      },
      {
        key: "branch.branch_code",
        label: "分店代號",
      },
      {
        key: "created_at",
        label: "異動時間",
        sortable: true,
      },
      {
        key: "start_at",
        label: "開始時間",
        sortable: true,
      },
      {
        key: "expired_at",
        label: "到期時間",
        sortable: true,
      },
      {
        key: "actions",
        label: "管理",
      },
      {
        key: "merchant_name",
        label: "通路名稱",
      }
    ];
    return {
      isLoading: false,
      pointLogs: [],
      merchantId: null,
      merchants: [{ value: null, text: "全部" }],
      perPage: 15,
      currentPage: 1,
      total: 0,
      availablePoint: null,
      zh,
      point: {
        point: null,
        description: null,
        memo: '後台手動調整',
        type: 1, // 更新點數
        start_at_date: new Date(),
        start_at_time: {
          HH: "00",
          mm: "00",
        },
        expired_at_date: null,
        expired_at_time: {
          HH: "23",
          mm: "59",
        },
      },
      pointForUse: {
        point: null,
        description: null,
        memo: '後台手動調整',
        type: 2,
      },
      isSubmittingUse: false,
      isSubmittingAdd: false,
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
        branch_id: null,
        event_id: null,
        keyword: "",
        sort_by: "created_at",
        order_by: "desc",
        merchant_id: null,
        target_type: this.upperTargetType,
        target_id: this.upperTargetId,
        type: null,

      },
      baseFields: baseFields,
      fields: baseFields,
      typeOptions: [
        { value: null, text: "請選擇 加點或扣點" },
        { value: 1, text: "加點" },
        { value: 2, text: "扣點" },
      ],
      // 新增異動來源選項
      sourceOptions: [
        { value: null, text: "請選擇異動來源" },
        { value: "RewardMission", text: "集點卡任務" },
        { value: "RewardCard", text: "集點卡" },
        { value: "RedeemCodeBundle", text: "優惠券" },
        { value: "ProductSku", text: "商品項目" },
        { value: "Product", text: "商品" },
        { value: "Order", text: "訂單" },
        { value: "Gift", text: "贈品" },
        { value: "OuterPointSource", text: "外部點數來源" },
        { value: "AddByStaff", text: "後台手動給點" },
        { value: "MinusByStaff", text: "後台手動扣點" },
        { value: "Point", text: "點數異動" },
        { value: "MarketingConfig", text: "自動化事件" },
      ],
      branches: [],
      allBranches: [],
      selectedBranch: {},
      selectedMerchant: {},
      selectedType: {},
      selectedSource: {},
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
      defaultMerchantType: (state) => state.defaultMerchantType,
    }),
    filteredFields() {
      return this.fields.filter(
        (field) => !this.excludeFields.includes(field.key)
      );
    },
    showAddButton() {
      return (
        this.upperCustomerId &&
        this.$permissions.has(this.$permissions.consts.POINT_LIST_CREATE)
      );
    },
    showUseButton() {
      return (
        this.upperCustomerId &&
        this.$permissions.has(this.$permissions.consts.POINT_LIST_DEDUCT)
      );
    },
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
    filteredQuery() {
      return Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries(this.query).filter(([key, value]) => value !== null)
        // eslint-enable-next-line no-unused-vars
      );
    },
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    branchOptions() {
      const options = [];

      // 請選擇分店
      if (this.checkPermission([this.$permissions.consts.POINT_LOGS_NO_BRANCH, this.$permissions.consts.POINT_LOGS_BRANCH])) {
        options.push({
          value: null,
          text: '請選擇分店',
        });
      }

      // 是否可看「品牌組織階層(無隸屬分店)」
      if (this.checkPermission([this.$permissions.consts.POINT_LOGS_NO_BRANCH])) {
        options.push({
          value: 'null',
          text: '品牌組織階層(無隸屬分店)',
        });
      }

      // 是否可看分店
      let branches = [];
      if (this.checkPermission([this.$permissions.consts.POINT_LOGS_BRANCH])) {
        branches = this.myBranches
          .slice()
          .sort((a, b) =>
            a.level === b.level
              ? a.order - b.order
              : a.level - b.level
          );
      }

      return [
        ...options,
        ...branches.map(branch => ({
          value: branch.id,
          text: this.displayBranchName(branch),
        })),
      ];
    },
    disabledBranchSelect() {
      return !this.checkPermission([this.$permissions.consts.POINT_LOGS_BRANCH])
    },
    ...mapGetters('general', [
      'myBranches',
    ]),
  },
  mounted() {
    this.fetchMerchants();
    this.fetchFields();

    if (this.$permissions.has(this.$permissions.consts.BRANCH_TOP_VIEW)) {
      this.fetchAllBranches();
    }

    if (this.query.branch_id === null) {
      this.query.branch_id = this.branchOptions[0]?.value ?? null;
    }

    this.initialized = true;
    this.checkAndExpandAdvancedSearch();
  },
  async created() {
    this.query = updateQueryFromRoute(
      this.$route,
      this.$store,
      this.query
    );
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        // 使用 updateUrlWithoutReload 僅更新 URL 與 Store，而不觸發路由跳轉
        // 這樣在會員詳情頁時就不會因為路由參數變動而導致整頁重刷
        updateUrlWithoutReload(this.query, this.$store, this.$route);
        this.fetchPointLogs();
      },
    },
    $route(to) {
      if (!this.initialized) return;
      this.query = updateQueryFromRoute(
        to,
        this.$store,
        this.query
      );
      this.syncSelectedOptions();
      this.fetchPointLogs();
    },
  },
  methods: {
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    checkAndExpandAdvancedSearch() {
      // 排除基本參數，只有在有進階過濾條件時才自動展開
      const advancedParams = [
        'branch_id',
        'event_id',
        'type',
        'target_type',

        'keyword'
      ];
      const hasAdvancedParams = Object.keys(this.$route.query).some(key => advancedParams.includes(key));

      if (hasAdvancedParams) {
        this.$nextTick(() => {
          // 只針對篩選區塊進行展開
          this.$root.$emit('bv::toggle::collapse', 'collapse-filter');
        });
      }
    },
    async fetchPointLogs() {
      try {
        this.isLoading = true;

        const params = {
          // 若帶入的參數為 null，api 參數會被轉成 null 字串，所以這邊多一個判斷將 null 變成空字串
          customer_id: this.upperCustomerId || "",
          ...this.filteredQuery,
        };

        const { data } = await pointLogApi.getPointLogs(
          this.upperMerchantId || this.query.merchant_id,
          params
        );
        this.total = data.meta.total;
        this.perPage = data.meta.per_page;
        this.pointLogs = data.data;

        // 只有在查看特定會員的點數歷程時才計算累計點數
        if (this.upperCustomerId) {
          await this.fetchCumulativePoints();
        }
      } catch (error) {
        console.log("");
      }
      this.isLoading = false;
    },
    async fetchCumulativePoints() {
      try {
        const params = {
          customer_id: this.upperCustomerId,
          merchant_id: this.upperMerchantId || this.query.merchant_id,
        };
        const { data } = await pointApi.getPersonalPoint(params);

        // 使用後端計算的累積點數
        this.availablePoint = data.data.available_point;
      } catch (error) {
        console.log("Error fetching cumulative points:", error);
        this.availablePoint = 0;
      }
    },
    async handleExport() {
      if (this.query.merchant_id) {
        const params = Object.fromEntries(
          // eslint-disable-next-line no-unused-vars
          Object.entries(this.query).filter(([key, value]) => value !== null && ! ['page', 'per_page'].includes(key))
          // eslint-enable-next-line no-unused-vars
        );
        const searchParams = new URLSearchParams({
          ...params,
          customer_id: this.upperCustomerId || "",
          prefix_file_name: this.prefixFileName || "",
          token: store.state.auth.token,
        });

        try {
          this.isLoading = true;

          await pointLogApi.exportPointLogs(searchParams, this.query.merchant_id)

          this.$swal({
            title: '成功',
            text: "可至“我的主控台”查看紀錄及下載檔案",
            showCancelButton: true,
            cancelButtonText: '確認',
            type: 'success',
            confirmButtonText: '前往查看',
          }).then((result)=>{
            if (result.value) {
              this.$router.push({
                name: "MyConsoleDownloadFileList",
                params: { org_code: this.$route.params.org_code },
              });
            }
          });
        } catch (e) {
          console.log(e)
        } finally {
          this.isLoading = false;
        }
      }
    },
    async fetchMerchants() {
      this.isLoading = true;
      const { data } = await merchantApi.list();

      this.merchants = [
        { value: null, text: "全部" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: `${merchant.name} (${merchant.type_name})`,
          };
        }),
      ];

      // 若有傳入 upperMerchantId (如會員詳情頁)，則同步至 query 確保按鈕與功能正常
      if (this.upperMerchantId) {
        this.query.merchant_id = this.upperMerchantId;
      }

      if (!this.query.merchant_id && this.showFilter) {
        const defaultMerchant = data.data.find((merchant) => merchant.type === this.defaultMerchantType) ??
          data.data.find((merchant) => merchant.type === consts.MERCHANT_TYPES.LINE_TYPE);

        if (defaultMerchant) {
          this.query.merchant_id = defaultMerchant.id;
        }
      }

      await this.fetchPointLogs();
      this.syncSelectedOptions();
      this.isLoading = false;
    },
    handleSort(ctx) {
      this.query.sort_by = ctx.sortBy;
      this.query.order_by = ctx.sortDesc ? "desc" : "asc";
      this.query.page = 1;
      updateUrlWithoutReload(this.query, this.$store, this.$route);
      this.fetchPointLogs();
    },
    handleSearch() {
      if (this.query.merchant_id) {
        this.handlePageResetWithoutReload();
      }
      this.fetchPointLogs();
    },
    showExpiredAt(pointLog) {
      if (pointLog.batch_total_points < 0) {
        return null;
      }

      const expiredAt = pointLog?.point?.expired_at;
      return expiredAt ? this.formatDate(expiredAt) : "無期限";
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("YYYY-MM-DD HH:mm");
      }
    },
    async usePoint() {
      if (this.isSubmittingUse) {
        return;
      }

      try {
        this.isSubmittingUse = true;

        const pointValue = this.pointForUse.point !== null && this.pointForUse.point !== undefined
          ? Math.abs(Number(this.pointForUse.point))
          : null;

        await pointApi.usePoint(this.upperMerchantId, {
          customer_id: this.upperCustomerId,
          ...this.pointForUse,
          point: pointValue
        });
        this.$swal.fire({
          title: "扣除成功",
          type: "success",
        });
      } catch (error) {
        this.$swal.fire({
          title: "新增失敗",
          type: "error",
        });
        console.log(error);
      } finally {
        this.isSubmittingUse = false;
        this.$bvModal.hide("modal-use");
        this.fetchPointLogs();
      }
    },
    async addPoint() {
      if (this.isSubmittingAdd) {
        return;
      }

      try {
        this.isSubmittingAdd = true;
        this.point.customer_id = this.upperCustomerId;

        // 格式化時間
        const payload = { ...this.point };

        if (payload.start_at_date) {
            payload.start_at = format(
                set(new Date(payload.start_at_date), {
                    hours: Number(payload.start_at_time.HH || 0),
                    minutes: Number(payload.start_at_time.mm || 0),
                    seconds: 0,
                }),
                "yyyy-MM-dd HH:mm:ss"
            );
        } else {
            payload.start_at = null;
        }

        if (payload.expired_at_date) {
            payload.expired_at = format(
                set(new Date(payload.expired_at_date), {
                    hours: 23,
                    minutes: 59,
                    seconds: 59,
                }),
                "yyyy-MM-dd HH:mm:ss"
            );
        } else {
            payload.expired_at = null;
        }

        // 移除輔助欄位
        delete payload.start_at_date;
        delete payload.start_at_time;
        delete payload.expired_at_date;
        delete payload.expired_at_time;

        await pointApi.storePoint(this.upperMerchantId, payload);
        this.$swal.fire({
          title: "新增成功",
          type: "success",
        });
      } catch (error) {
        this.$swal.fire({
          title: "新增失敗",
          type: "error",
        });
        console.log(error);
      } finally {
        this.isSubmittingAdd = false;
        this.$bvModal.hide("modal-add");
        this.fetchPointLogs();
      }
    },
    handlePageChange(newPage) {
      this.query.page = newPage;
    },
    handlePerPageChange(newPerPage) {
      this.query.per_page = newPerPage;
      this.query.page = 1;
    },
    async fetchFields() {
      let normalizeProfileFields = await this.normalizeProfileFields();
      // 找到插入的位置
      const insertIndex = this.baseFields.findIndex(
        (field) => field.key === "batch_total_points"
      );

      // 創建新的欄位陣列，插入 normalizeProfileFields
      this.fields = [
        ...this.baseFields.slice(0, insertIndex), // 從開頭到插入點之前的欄位
        ...normalizeProfileFields,          // 插入 normalizeProfileFields
        ...this.baseFields.slice(insertIndex),   // 插入點之後的欄位
      ];
    },
    async normalizeProfileFields() {
      const customerList = this.getModuleConfig("customer", "reward.customer_list");

      const profileMappings = customerList?.[0]?.member_fields ?? [];

      if (profileMappings) {
        return profileMappings.map((mapping) => {
          if (mapping.matched_key.startsWith("extra.")) {
            const key = mapping.matched_key.split("extra.")[1];
            return {
              key: `profiles.${key}`,
              label: mapping.title,
            };
          } else {
            return {
              key: mapping.matched_key,
              label: mapping.title,
            };
          }
        });
      } else {
        return [];
      }
    },
    async handleFilterChange() {
      // 暫時關閉 watcher，避免 updateUrl 被呼叫導致路由更新（父組件重整）
      const prevInitialized = this.initialized;
      this.initialized = false;

      try {
        this.query.page = 1;
        await this.fetchPointLogs();
      } finally {
        // 恢復 initialized，但不強制觸發 updateUrl（避免父層被重整）
        this.initialized = prevInitialized;
      }
    },
    resetPointForUse() {
      this.pointForUse.point = null;
      this.pointForUse.description = null;
    },
    resetPoint() {
      this.point.point = null;
      this.point.description = null;
      this.point.start_at_date = new Date();
      this.point.start_at_time = {
        HH: "00",
        mm: "00",
      };
      this.point.expired_at_date = null;
      this.point.expired_at_time = {
        HH: "23",
        mm: "59",
      };
    },
    async fetchAllBranches() {
      const { data } = await branchApi.getBranches(this.organization, { is_all: true });
      this.allBranches = data.data.sort((a, b) => {
        if (a.level === b.level) {
          return a.order - b.order;
        }
        return a.level - b.level;
      });

      if (this.query.branch_id !== null) {
        this.selectedBranch = this.branchOptions.find(
          (option) => option.value === this.query.branch_id
        );
      } else {
        this.selectedBranch = this.branchOptions[0];
      }
    },
    branchChange() {
      this.query.branch_id = this.selectedBranch?.value ?? null;

      this.handlePageReset();
    },
    displayBranchName(branch) {
      if (branch.level > 1) {
        return '-'.repeat(branch.level - 1) + ` ${branch.branch_code} ${branch.name}`
      }
      return `${branch.branch_code} ${branch.name}`
    },
    syncSelectedOptions() {
      // 使用寬鬆比較 (==) 以處理 string/number 差異
      this.selectedMerchant = this.merchants.find(o => o.value == this.query.merchant_id) || this.merchants[0] || {};
      this.selectedType = this.typeOptions.find(o => o.value == this.query.type) || this.typeOptions[0] || {};
      this.selectedSource = this.sourceOptions.find(o => o.value == this.query.target_type) || this.sourceOptions[0] || {};

    },
    onMerchantChange(option) {
      this.query.merchant_id = option?.value ?? null;
      this.handleFilterChange();
    },
    onTypeChange(option) {
      this.query.type = option?.value ?? null;
      this.handleFilterChange();
    },
    onSourceChange(option) {
      this.query.target_type = option?.value ?? null;
      this.handleFilterChange();
    },

  },
};
</script>
